<template>
  <div class="layout my_account">
    <div class="account_top">
      <p>账户余额：</p>
      <div class="top_bottom">
        <p><span>{{wCount(balance)}}</span>金豆</p>
        <div class="buy_btn" v-if="false">
          <span>购买/充值</span>
        </div>
      </div>
      <img src="../../../assets/img/new/jindou.png" >
    </div>
    <div class="account_con">
      <van-tabs v-model="activeName" sticky line-width="0.54rem" line-height="0.04rem" color="#ff5c00" title-inactive-color="#666" title-active-color="#ff5c00">
        <van-tab title="收入" name="income">
          <incomeList v-if="activeName=='income'"></incomeList>
        </van-tab>
        <van-tab title="支出" name="expend">
          <expendList v-if="activeName=='expend'"></expendList>
        </van-tab> 
        <van-tab title="规则" name="rule" >
          <div class="rule_con">
            <p>金豆获取规则：</p>
            <p>金豆是平台专属虚拟货币，在展商秀平台下所有展会中均可使用，可用于助力，送礼物等，获取途径：官方赠送，或联系主办方</p>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import incomeList from "./components/income-list";  //资讯
import expendList from "./components/expend-list";  //资讯
export default {
  name: "my-account",
  components:{
    incomeList,
    expendList
  },
  data() {
    return {
      activeName:'',
      balance:0,
      headTab:[
        {title: '收入',name:'income'},
        {title: '支出',name:'expend'},
        {title: '规则',name:'rule'},
      ],
    } 
  },
  async created(){
    this.activeName=this.navTab;
    this.balance=await this.getBanlance(this.userInfo.id);
  },
  mounted(){
  },
  computed: {
    ...mapGetters({
      userInfo:'getUserInfo'
    }),
    navTab(){
      return this.$route.query.navTab
    }
  },
  methods:{
    ...mapActions({
      getBanlance:'act/getBanlance'
    }),
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
  }
};
</script>

<style lang="scss" scoped>
.my_account{
  .account_top{
    padding:0 0.3rem;
    height: 2.4rem;
    width: 100%;
    color: #fff;
    background-image: linear-gradient(45deg, #ff8039 0%,#ffcf5c 100%);
    position: relative;
    border-bottom: 0.2rem solid #f2f2f2;
    >p{
      font-size: 0.26rem;
      font-weight: bold;
      padding-top: 0.55rem ;
    }
    .top_bottom{
      position: relative;
      z-index: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.25rem;
      p{
        font-size: 0.26rem;
        span{
          font-size: 0.48rem;
          margin-right: 0.2rem;
        }
      }
      .buy_btn{
        width: 1.72rem;
        height: 0.6rem;
        border-radius: 0.3rem;
        
        font-size: 0.26rem;
        border:0.06rem solid rgba($color: #ff5c00, $alpha: 0.2);
        span{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 0.3rem;
          background:#ff5c00;
        }
      }
    }
    img{
      position: absolute;
      right: 0;
      bottom: 0;
      width: 1.2rem;
      height: 1.16rem;
      z-index: 0;
    }
  }
  .account_con{
    ::v-deep .van-tabs{
      .van-tabs__wrap{
        height: 0.9rem;
        border-bottom: 0.01rem solid #e6e6e6;
        .van-tab{
          .van-tab__text{
            font-size: 0.3rem;
            font-weight: bold;
          }
        }
      }
      .van-tabs__content{
        .van-tab__pane{
          .rule_con{
            padding: 0.3rem;
            color: #333;
            p{
              font-size: 0.26rem;
              margin-bottom: 0.2rem;
              &:last-child{
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
